import { FC, lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { useAuthContext } from '../context/hook/useAuthContext';
import { BarcodeInputContextProvider } from '../../../common/context/barcode-input-context/BarcodeInputContextProvider';
import { HbsSampleUpdatesContextProvider } from '../../../common/context/hbs/HbsSampleUpdatesContextProvider';
import { canToggleCommandPalette } from '../../command-palette/util/canToggleCommandPalette';
import { PermissionCheckComponent } from '../../../common/component/layout/PermissionCheckComponent';
import { PermissionType } from '../../security/type/PermissionType';
import { UserSetup } from './UserSetup';

const CommandPaletteContainer = lazy(() =>
  // We need to make this call inside lazy.
  // If called in the module scope, CspConfigService will not be initialized yet.
  canToggleCommandPalette()
    ? import('../../command-palette/container/CommandPaletteContainer').then(module => ({
        default: module.CommandPaletteContainer,
      }))
    : Promise.resolve({ default: () => null }),
);

export const AuthenticatedRoute: FC = () => {
  const { isNotAuthenticated } = useAuthContext();

  if (isNotAuthenticated) {
    return <Navigate replace to={CspPath.LOGIN} />;
  }

  return (
    <UserSetup>
      <BarcodeInputContextProvider>
        <HbsSampleUpdatesContextProvider>
          <PermissionCheckComponent permission={PermissionType.CAN_USE_COMMAND_PALETTE} fallback={null}>
            <CommandPaletteContainer />
          </PermissionCheckComponent>
          <Outlet />
        </HbsSampleUpdatesContextProvider>
      </BarcodeInputContextProvider>
    </UserSetup>
  );
};
